import { useCallback, useEffect, useRef } from 'react'

export const useDebouncedCallback = <T extends (...args: any[]) => void>(
    callback: T,
    delay: number,
): ((...args: Parameters<T>) => void) => {
    const callbackRef = useRef(callback)
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

    useEffect(() => {
        callbackRef.current = callback
    }, [callback])

    useEffect(
        () => () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        },
        [delay],
    )

    return useCallback(
        (...args: Parameters<T>) => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
            timeoutRef.current = setTimeout(() => {
                callbackRef.current(...args)
            }, delay)
        },
        [delay],
    )
}
